<aside *ngIf="!env.USE_TAILWIND">
    <div class="block__left-side-panel">
        <div class="text-items">
            <h1>
                {{ 'GET_STARTED_WITH_FREE_ACCOUNT_TITLE' | translate }}
            </h1>
            <p class="text-items__description" ridangoTranslatedLink>
                {{ 'GET_STARTED_WITH_FREE_ACCOUNT_DESCRIPTION' | translate }}
            </p>
            <p class="text-items__description">
                <span style="padding-right: 3px">{{ 'ALREADY_HAVE_AN_ACCOUNT' | translate }}</span>
                <a class="link link--action link--emphasized" [routerLink]="'/login' | localize">{{
                    'LOG_IN_HERE_LINK' | translate
                }}</a>
            </p>
        </div>
    </div>
</aside>

<ng-container *ngIf="env.USE_TAILWIND">
    <div class="word-break">
        <h1 class="mb-5 text-5xl leading-tight lg:text-6xl">
            {{ 'GET_STARTED_WITH_FREE_ACCOUNT_TITLE' | translate }}
        </h1>

        <p class="mb-5 md:max-w-xl" ridangoTranslatedLink>
            {{ 'GET_STARTED_WITH_FREE_ACCOUNT_DESCRIPTION' | translate }}
        </p>

        <p class="md:max-w-xl">
            <span class="mr-1">{{ 'ALREADY_HAVE_AN_ACCOUNT' | translate }}</span>
            <a class="pn-light:text-primary ml-1 text-secondary" [routerLink]="'/login' | localize">
                {{ 'LOG_IN_HERE_LINK' | translate }}
            </a>
        </p>
    </div>
</ng-container>
